// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as LoadingCard$LiveRoom from "./LoadingCard.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as NBAAgreement$LiveRoom from "./NBAAgreement.bs.js";
import * as SelectString$LiveRoom from "./SelectString.bs.js";
import * as Form from "@sothebys/sterling/form";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as ClientapiQueries$LiveRoom from "../ClientapiQueries.bs.js";
import * as ConfirmCondition$LiveRoom from "../pages/auctionRoom/ConfirmCondition.bs.js";
import * as Utils_Agreements$LiveRoom from "../Utils/Utils_Agreements.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";
import * as SelectAccountHelpers$LiveRoom from "./SelectAccountHelpers.bs.js";

function SelectAccount$MessageBox$Box(props) {
  var bgColor = props.bgColor;
  var bgColor$1 = bgColor !== undefined ? bgColor : Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.width(Css.pct(100)),
                    tl: {
                      hd: Css.paddingLeft(Css.pt(16)),
                      tl: {
                        hd: Css.paddingRight(Css.pt(16)),
                        tl: {
                          hd: Css.paddingTop(Css.pt(8)),
                          tl: {
                            hd: Css.paddingBottom(Css.pt(8)),
                            tl: {
                              hd: Css.marginTop(Css.px(16)),
                              tl: {
                                hd: Css.backgroundColor(bgColor$1),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, props.children);
}

var Box = {
  make: SelectAccount$MessageBox$Box
};

function SelectAccount$MessageBox$ShippingChina(props) {
  return React.createElement(SelectAccount$MessageBox$Box, {
              bgColor: Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag),
              children: null
            }, React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  children: "买家仅可在中国大陆境内收到拍品。"
                }), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(12)),
                        tl: /* [] */0
                      }),
                  children: "Lots in this sale can only be shipped within mainland China."
                }), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  children: "阁下使用银行转账付款的，我们仅接受来自中国大陆境内开立的银行账户的人民币付款。"
                }), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(12)),
                        tl: /* [] */0
                      }),
                  children: "We accept wire transfer only in RMB from bank accounts opened in mainland China."
                }), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  children: "阁下使用信用卡或借记卡付款的，阁下必须亲身持卡前往苏富比位于上海或北京办公室付款。"
                }), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  children: "Credit card and debit card payments must be made in person by the cardholder at Sotheby’s Beijing or Shanghai office."
                }));
}

var ShippingChina = {
  make: SelectAccount$MessageBox$ShippingChina
};

function SelectAccount$MessageBox$NBAAgreement(props) {
  return React.createElement(SelectAccount$MessageBox$Box, {
              bgColor: Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag),
              children: React.createElement(NBAAgreement$LiveRoom.make, {
                    agreementStatuses: props.agreementStatuses,
                    onUpdateAgreementStatuses: props.onUpdateAgreementStatuses
                  })
            });
}

var NBAAgreement = {
  make: SelectAccount$MessageBox$NBAAgreement
};

var MessageBox = {
  Box: Box,
  ShippingChina: ShippingChina,
  NBAAgreement: NBAAgreement
};

function SelectAccount$PurchasingForCheck(props) {
  var onRadioButtonChanged = props.onRadioButtonChanged;
  var checked = props.checked;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var checkedAgent = checked[0];
  var checkedMe = checked[1];
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.flexDirection("column"),
                      tl: {
                        hd: Css.marginTop(Css.px(24)),
                        tl: /* [] */0
                      }
                    }
                  })
            }, React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(8)),
                        tl: /* [] */0
                      }),
                  children: Curry._1(t, "BidAgentDisclosure_statement")
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "iDeclareThat"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.display("flex"),
                              tl: {
                                hd: Css.flexDirection("column"),
                                tl: {
                                  hd: Css.width("fitContent"),
                                  tl: {
                                    hd: Css.selector(" p", {
                                          hd: Css.display("contents"),
                                          tl: {
                                            hd: Css.marginLeft(Css.px(8)),
                                            tl: /* [] */0
                                          }
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            })
                      }, React.createElement(Form.Radio, {
                            name: "" + "SelectAccount-LiveRoom" + "_Myself",
                            checked: checkedMe,
                            onChange: (function (param) {
                                Curry._2(onRadioButtonChanged, false, true);
                              }),
                            children: Caml_option.some(React.createElement(PropSpread$LiveRoom.make, {
                                      data: {
                                        hd: {
                                          TAG: /* TestId */1,
                                          _0: "bidMySelf"
                                        },
                                        tl: /* [] */0
                                      },
                                      children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                                            className: Curry._1(Css.style, {
                                                  hd: Css.marginBottom(Css.px(8)),
                                                  tl: {
                                                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                                          hd: Css.fontSize(Css.px(14)),
                                                          tl: {
                                                            hd: Css.lineHeight(Css.px(18)),
                                                            tl: /* [] */0
                                                          }
                                                        }),
                                                    tl: /* [] */0
                                                  }
                                                }),
                                            children: Curry._1(t, "BidAgentDisclosure_optionMyself")
                                          })
                                    }))
                          }), React.createElement(Form.Radio, {
                            name: "" + "SelectAccount-LiveRoom" + "_Agent",
                            checked: checkedAgent,
                            onChange: (function (param) {
                                Curry._2(onRadioButtonChanged, true, false);
                              }),
                            children: Caml_option.some(React.createElement(PropSpread$LiveRoom.make, {
                                      data: {
                                        hd: {
                                          TAG: /* TestId */1,
                                          _0: "bidOnBehalf"
                                        },
                                        tl: /* [] */0
                                      },
                                      children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                                            className: Curry._1(Css.style, {
                                                  hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                                        hd: Css.fontSize(Css.px(14)),
                                                        tl: {
                                                          hd: Css.lineHeight(Css.px(18)),
                                                          tl: /* [] */0
                                                        }
                                                      }),
                                                  tl: /* [] */0
                                                }),
                                            children: Curry._1(t, "BidAgentDisclosure_optionAgent")
                                          })
                                    }))
                          }))
                }));
}

var PurchasingForCheck = {
  make: SelectAccount$PurchasingForCheck
};

function SelectAccount$SelectAccountForm(props) {
  var userAccounts = props.userAccounts;
  var additionalStyles = props.additionalStyles;
  var auctionLocation = props.auctionLocation;
  var onAccountSelected = props.onAccountSelected;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = React.useState(function () {
        if (userAccounts.length === 1) {
          return Belt_Array.get(userAccounts, 0);
        }
        
      });
  var setSelectedAccount = match$1[1];
  var selectedAccount = match$1[0];
  React.useEffect((function () {
          if (selectedAccount !== undefined) {
            Curry._1(onAccountSelected, selectedAccount.id);
          }
          
        }), [selectedAccount]);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.paddingTop(Css.px(14)),
                    tl: /* [] */0
                  })
            }, React.createElement(SelectString$LiveRoom.make, {
                  itemList: userAccounts,
                  value: selectedAccount !== undefined ? ({
                        TAG: /* SelectedItem */1,
                        _0: selectedAccount
                      }) : ({
                        TAG: /* Placeholder */0,
                        _0: Curry._1(t, "ConfirmAccount_sothebysAccountNr")
                      }),
                  name: "account-number",
                  onSelect: (function (item) {
                      var accountId = item[0];
                      Curry._1(setSelectedAccount, (function (param) {
                              return Belt_Array.getBy(userAccounts, (function (account) {
                                            return account.id === accountId;
                                          }));
                            }));
                    }),
                  title: Curry._1(t, "ConfirmAccount_sothebysAccountNr"),
                  mayShowTitle: false
                }), React.createElement("div", {
                  className: Curry._1(Css.style, Belt_Option.getWithDefault(additionalStyles, /* [] */0))
                }, Caml_obj.equal(SelectAccountHelpers$LiveRoom.getAuctionLocationType(auctionLocation), "SHANGHAI") ? React.createElement(SelectAccount$MessageBox$ShippingChina, {}) : null), React.createElement(SelectAccount$PurchasingForCheck, {
                  checked: props.purchasingForCheckState,
                  onRadioButtonChanged: props.onRadioButtonPurchasingForChanged
                }), React.createElement("div", {
                  className: Curry._1(Css.style, Belt_Option.getWithDefault(additionalStyles, {
                            hd: Css.paddingTop(Css.px(2)),
                            tl: /* [] */0
                          }))
                }, React.createElement(ConfirmCondition$LiveRoom.make, {
                      onCheckboxChanged: props.onCheckboxChanged,
                      conditionOfSaleText: props.conditionOfSaleText,
                      auctionLocation: auctionLocation,
                      checked: props.conditionsOfSaleChecked
                    })), Belt_Array.some(props.agreements, (function (agreement) {
                    if (agreement.agreementId === Utils_Agreements$LiveRoom.nbaAgreementId) {
                      return !Belt_Option.getWithDefault(agreement.accepted, false);
                    } else {
                      return false;
                    }
                  })) ? React.createElement(SelectAccount$MessageBox$NBAAgreement, {
                    agreementStatuses: props.agreementStatuses,
                    onUpdateAgreementStatuses: props.onUpdateAgreementStatuses
                  }) : null);
}

var SelectAccountForm = {
  make: SelectAccount$SelectAccountForm
};

function SelectAccount(props) {
  var additionalStyles = props.additionalStyles;
  var auctionLocation = props.auctionLocation;
  var partyAccountsRes = Curry.app(ClientapiQueries$LiveRoom.SelectAccount.PartyAccountsQuery.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var match = partyAccountsRes.data;
  if (partyAccountsRes.error === undefined && !partyAccountsRes.loading) {
    if (match === undefined) {
      return null;
    }
    var match$1 = match.me;
    var status = match$1.status;
    var activeAccounts = typeof status === "object" ? (
        status.NAME === "TransactionalUserStatus" ? status.VAL.activeAccounts : []
      ) : [];
    var activeUserAccounts = SelectAccountHelpers$LiveRoom.getActivePartyAccounts(match$1.partyAccounts, activeAccounts, auctionLocation);
    return React.createElement(SelectAccount$SelectAccountForm, {
                onAccountSelected: props.onAccountSelected,
                auctionLocation: auctionLocation,
                onCheckboxChanged: props.onCheckboxChanged,
                conditionOfSaleText: props.conditionOfSaleText,
                conditionsOfSaleChecked: props.conditionsOfSaleChecked,
                additionalStyles: additionalStyles,
                userAccounts: activeUserAccounts,
                onRadioButtonPurchasingForChanged: props.onRadioButtonPurchasingForChanged,
                purchasingForCheckState: props.purchasingForCheckState,
                agreements: props.agreements,
                agreementStatuses: props.agreementStatuses,
                onUpdateAgreementStatuses: props.onUpdateAgreementStatuses
              });
  }
  return React.createElement(LoadingCard$LiveRoom.ConfirmAccount.make, {
              className: Curry._1(Css.style, Belt_Option.getWithDefault(additionalStyles, /* [] */0))
            });
}

var PartyAccountsQuery = ClientapiQueries$LiveRoom.SelectAccount.PartyAccountsQuery;

var make = SelectAccount;

export {
  PartyAccountsQuery ,
  MessageBox ,
  PurchasingForCheck ,
  SelectAccountForm ,
  make ,
}
/* Css Not a pure module */
